import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sv2-share-takeover" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "sv2-share-takeover__content" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Select a method to share your screen", -1)
const _hoisted_6 = { class: "sv2-share-grid" }
const _hoisted_7 = {
  type: "button",
  class: "sv2-share-card"
}
const _hoisted_8 = { class: "sv2-share-card__icon" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-card__option" }, "Option 1", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-card__title" }, "Install", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-card__desc" }, "Install the Ditto Connect app to begin sharing.", -1)
const _hoisted_12 = {
  type: "button",
  class: "sv2-share-card"
}
const _hoisted_13 = { class: "sv2-share-card__icon" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-card__option" }, "Option 2", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-card__title" }, "Download", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-card__desc" }, " Download and run a temporary version of the Ditto Connect app. ", -1)
const _hoisted_17 = {
  type: "button",
  class: "sv2-share-card"
}
const _hoisted_18 = { class: "sv2-share-card__icon" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-card__option" }, "Option 3", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-card__title" }, "Continue", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-card__desc" }, "Share your screen with this browser.", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "sv2-share-help" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-help__label" }, "NEED HELP?"),
  /*#__PURE__*/_createElementVNode("p", { class: "sv2-share-help__body" }, [
    /*#__PURE__*/_createTextVNode(" Email "),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:help@goditto.com" }, "help@goditto.com"),
    /*#__PURE__*/_createTextVNode(" for assistance. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ph_arrow_left = _resolveComponent("ph-arrow-left")!
  const _component_ph_cloud_arrow_down = _resolveComponent("ph-cloud-arrow-down")!
  const _component_ph_download = _resolveComponent("ph-download")!
  const _component_ph_arrow_circle_right = _resolveComponent("ph-arrow-circle-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.customBg,
      alt: "",
      class: "sv2-share-takeover__bg"
    }, null, 8, _hoisted_2),
    _createElementVNode("button", {
      class: "sv2-share-takeover__back",
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
    }, [
      _createVNode(_component_ph_arrow_left, {
        size: 14,
        weight: "bold"
      }),
      _createTextVNode(" Back ")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.strideLogo,
        alt: "StrideUX",
        style: {"width":"100%","max-width":"240px","height":"auto"}
      }, null, 8, _hoisted_4),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_ph_cloud_arrow_down, {
              size: 26,
              weight: "fill"
            })
          ]),
          _hoisted_9,
          _hoisted_10,
          _hoisted_11
        ]),
        _createElementVNode("button", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, [
            _createVNode(_component_ph_download, {
              size: 26,
              weight: "fill"
            })
          ]),
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ]),
        _createElementVNode("button", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, [
            _createVNode(_component_ph_arrow_circle_right, {
              size: 26,
              weight: "fill"
            })
          ]),
          _hoisted_19,
          _hoisted_20,
          _hoisted_21
        ])
      ]),
      _hoisted_22
    ])
  ]))
}